import { isCryptoTestMigrationEnabled } from "common/crypto/testMigrationConfig";

export const isSurveyHistoryTestModeEnabled = () => isCryptoTestMigrationEnabled();
